import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import MenuIcon from "@mui/icons-material/Menu";
import { BranchRobotsInfo } from "../pages/ErrorNotifications";
import { useNavigate } from "react-router-dom";
import SideMenu from "../templates/SideMenu";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import HomeIcon from "@mui/icons-material/Home";
import { Link } from "react-router-dom";
import UserMenu from "./UserMenu";

export let branchData: React.Context<BranchRobotsInfo | undefined>;

const drawerWidth: number = 0;

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const envUrlStatus = process.env.REACT_APP_STAGE || "/env_error";

type LayoutProps = {
  title: string;
  disableBack?: boolean;
  children: React.ReactNode;
};

//ベルマーク右上に表示する数字（エラー対処が必要なロボットの件数）をカウント用変数
//var robotsCount = 0;
const Layout: React.FC<LayoutProps> = ({ title, disableBack, children }) => {
  // サイドメニュー開閉状態
  const [open, setOpen] = React.useState(true);
  // サイドメニュー開閉処理
  const toggleDrawer = () => {
    setOpen(!open);
  };
  //画面遷移先にオブジェクトを渡すための関数
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar position="absolute" open={open}>
        {/* ヘッダー部分の実装 */}
        <Toolbar
          sx={{
            pr: "24px", // keep right padding when drawer closed
          }}
        >
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            sx={{ width: "100%" }}
            minWidth={0}
          >
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              minWidth={0}
              sx={{
                overflow: "hidden",
                flexShrink: 1,
              }}
            >
              {!disableBack && (
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="go back"
                  onClick={() => navigate(-1)}
                  sx={{
                    marginRight: "20px",
                  }}
                >
                  <ArrowBackIosOutlinedIcon />
                </IconButton>
              )}
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                onClick={toggleDrawer}
                sx={{
                  marginRight: "36px",
                  ...(open && { display: "none" }),
                }}
              >
                <MenuIcon />
                {/* サイドメニューを開閉できるボタン */}
              </IconButton>
              <Typography
                component="h1"
                variant="h6"
                color="inherit"
                noWrap
                sx={{ flexGrow: 1 }}
              >
                {title}
              </Typography>
            </Box>
            <Box sx={{ flexShrink: 0 }}>
              <UserMenu />
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <SideMenu /> {/* サイドメニューの表示 */}
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          flexGrow: 1,
          height: "100vh",
          overflow: "auto",
        }}
      >
        <Toolbar />
        <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
          {children}
          <Box mt={4}>
            <Typography variant="body2" color="text.secondary" align="center">
              {/* {getEnvUrlLabel(EnvUrl)} */}
              {envUrlStatus}
            </Typography>
          </Box>
          <Box mt={4}>
            <Typography variant="body2" color="text.secondary" align="center">
              {"Copyright © rdf-app"}
              {new Date().getFullYear()}
              {"."}
            </Typography>
          </Box>
        </Container>
      </Box>
      {/* フッター部分の実装 */}
      <Box
        component="footer"
        sx={{
          p: 3,
          backgroundColor: (theme) => theme.palette.primary.main,
          position: "fixed",
          bottom: 0,
          width: "100%",
          zIndex: 2,
          height: "60px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Link
          to={"/"}
          style={{
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            marginRight: 1,
          }}
        >
          <IconButton
            sx={{ color: "white", marginRight: "5px" }}
            aria-label="home"
          >
            <HomeIcon sx={{ fontSize: "2.5rem" }} />
          </IconButton>
          <Typography variant="body1" sx={{ color: "white" }}>
            ホームへ戻る
          </Typography>
        </Link>
      </Box>
    </Box>
  );
};

export default Layout;
